module.exports = __webpack_public_path__ + "static/img/sgz.4b85ed50.png";